import { isValid, parseISO } from "date-fns";

/** Calendar keys in discount maps must be parseable dates (e.g. yyyy-MM-dd). */
export function isDiscountAvailabilityDateKey(date: string): boolean {
  return typeof date === "string" && date.length > 0 && isValid(parseISO(date));
}
